import { Component, Input } from '@angular/core';
import { PermissionsService } from '../../../core/permissions.service';

@Component({
  standalone: false,
  selector: 'app-quote-status',
  templateUrl: './quote-status.component.html',
  styles: [`
    .status-label { font-size: 12px; }
    .status-new { color: #333; }
    .status-pricing { color: #f0ad4e; }
    .status-submitted { color: #5bc0de; }
    .status-ready { color: #5cb85c; font-weight: 600; }
    .status-ordered { color: #337ab7; }
    .status-expired { color: #999; }
    .status-denied { color: #d9534f; }
    .btn-buy {
      padding: 2px 8px;
      font-size: 11px;
      background: var(--brand-primary);
      color: #fff;
      border: none;
      border-radius: 3px;
      cursor: pointer;
    }
    .btn-buy:hover { opacity: 0.85; }
  `]
})
export class QuoteStatusComponent {
  @Input() quote: any;

  constructor(public perms: PermissionsService) {}

  get status(): number {
    return parseInt(this.quote?.customer_status ?? '0', 10);
  }

  get statusLabel(): string {
    switch (this.status) {
      case 0: return 'New';
      case 1: return 'Pricing Needed';
      case 2: return 'Submitted';
      case 3: return 'Ready to Buy';
      case 4: return 'Ordered';
      case 5: return 'Expired';
      case 7: return 'Denied';
      default: return '';
    }
  }

  get statusClass(): string {
    switch (this.status) {
      case 0: return 'status-new';
      case 1: return 'status-pricing';
      case 2: return 'status-submitted';
      case 3: return 'status-ready';
      case 4: return 'status-ordered';
      case 5: return 'status-expired';
      case 7: return 'status-denied';
      default: return '';
    }
  }
}
